<template>
  <div class="eleStatementPlan">
    <!--标题-->
    <div class="title">
      <p>
        <span @click="router.push('/admin/eleStatement')">用电报表</span>
        <span> / </span>
        <span>用电报表管理</span>
      </p>
      <p class="tit">
        <el-icon @click="goBack">
          <Back/>
        </el-icon>
        用电报表管理
      </p>
    </div>
    <!--列表-->
    <div class="content">
      <div class="contain">
        <!--新增查询-->
        <el-button class="addBtn" type="primary" @click="addClick">
          <el-icon>
            <Plus/>
          </el-icon>
          新增查询
        </el-button>
        <!--查询列表-->
        <el-table v-loading="loading" :data="tableData" style="width: 100%">
          <template #empty>
            <el-empty class="emptyClass" description="暂无数据信息"
                      image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
              <p>您可以在此页面新增查询方案</p>
            </el-empty>
          </template>
          <el-table-column label="查询名称" prop="queryName"></el-table-column>
          <el-table-column label="创建时间" prop="ct" sortable></el-table-column>
          <el-table-column label="创建人" prop="creator"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160px">
            <template #default="scope">
              <div class="opacity">
                <span v-if="scope.row.canCopyFlag" class="editClass btn"
                      @click.prevent="editClick(scope.row.id,scope.row,'copy')">复制</span>
                <span class="editClass btn" @click.prevent="editClick(scope.row.id,scope.row)">编辑</span>
                <span class="editClass btn delClass" @click.prevent="delClick(scope.row.id,scope.row)">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag">
          <el-pagination v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="total" background
                         layout="total,sizes,prev, pager, next" @size-change="handleSizeChange"
                         @current-change="pageChange"/>
        </div>
      </div>
    </div>
    <!--新增编辑弹窗-->
    <el-dialog v-model="dialogFormVisible" :close-on-click-modal="false" :title="formData.id?'编辑查询':'新建查询'"
               width="60%">
      <el-form ref="fromRef" :inline="true" :model="formData" :rules="formRules">
        <el-form-item label="查询名称" prop="queryName" style="width: 33%;">
          <el-input v-model="formData.queryName" placeholder="请输入查询名称"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type" style="width: 33%;">
          <el-radio-group v-model="formData.type">
            <el-radio :value="1">日</el-radio>
            <el-radio :value="2">月</el-radio>
            <el-radio :value="3">年</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="查询日期" prop="dateTime" style="width: auto;margin-right: 20px">
          <el-date-picker v-if="formData.type==1" v-model="formData.dateTime" end-placeholder="结束时间"
                          popper-class="date-style"
                          range-separator="→"
                          start-placeholder="开始时间"
                          type="daterange"
                          value-format="YYYY-MM-DD">
          </el-date-picker>
          <el-date-picker v-if="formData.type==2" v-model="formData.dateTime" end-placeholder="结束时间"
                          popper-class="date-style"
                          range-separator="→"
                          start-placeholder="开始时间"
                          type="monthrange"
                          value-format="YYYY-MM-DD">
          </el-date-picker>
          <el-date-picker v-if="formData.type==3"
                          v-model="formData.dateTime[0]"
                          :disabled-date="disabledDate"
                          placeholder="开始时间"
                          type="year" value-format="YYYY-MM-DD"
          />
          <div v-if="formData.type==3" class="segmentation" style="margin: 0 8px;transform: translateY(5px)">至</div>
          <el-date-picker v-if="formData.type==3"
                          v-model="formData.dateTime[1]"
                          :disabled-date="disabledDate2"
                          placeholder="结束时间"
                          type="year"
                          value-format="YYYY-MM-DD"
          />
        </el-form-item>
        <el-form-item label="展示方式" prop="chatType" style="width: 33%;">
          <el-select v-model="formData.chatType" placeholder="请选择展示方式">
            <el-option :value="1" label="折线图"></el-option>
            <el-option :value="0" label="柱状图"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button class="cancle resetButton" @click="dialogFormVisible=false">取消</el-button>
        <el-button class="confrim" type="primary" @click="save()">保存</el-button>
      </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {h, nextTick, onMounted, reactive, ref, watch} from "vue"
import './eleStatementPlan.less'

import {CloseBold, ZoomIn, Plus, Back, CircleClose, CirclePlus} from '@element-plus/icons-vue'
import {CascaderProps, ElMessage, ElMessageBox} from 'element-plus'
import {useRouter} from 'vue-router';
import qs from "qs";
import {
  delSearchListApi,
  editSearchListApi, getSearchDetailApi, getSearchListApiPag,
  saveSearchListApi
} from "@/api/modules/dataSearch";
import moment from "moment";
import {getAllTreeApi} from "@/api/modules/strategy";


let router = useRouter()
let route = useRouter()

// 返回
const goBack = function () {
  // router.push('/admin/dataSearch')
  router.go(-1)
}


// 方案列表-----------------------------------------------------------------
// 分页
let pageNumber = ref(1)
let pageSize = ref(20)
let total = ref()
// 更改每页多少
const handleSizeChange = function (e) {
  pageSize.value = e
  getSearchListFun()
}
// 跳转到某页
const pageChange = function (e) {
  pageNumber.value = e
  getSearchListFun()
}
// 表格数据
let tableData = ref([])
// 获取表格数据
let loading = ref(false)
const getSearchListFun = function () {
  loading.value = true
  getSearchListApiPag(qs.stringify({
    type: 0,
    pageSize: pageSize.value,
    pageNumber: pageNumber.value
  })).then(res => {
    loading.value = false
    if (res.data.code === 0) {
      tableData.value = res.data.result.list
      total.value = Number(res.data.result.total)
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


// 新增编辑-----------------------------------------------------------------
// 新增编辑弹窗
let dialogFormVisible = ref(false)
// 新增编辑表单数据
let formData = ref({
  queryName: '',
  type: 1,
  dateTime: [],
  chatType: 1,
  creator: window.localStorage.getItem('memberId'),
})
// 表单规则
let formRules = ref({
  queryName: [
    {required: true, message: '请输入查询方案名称', trigger: 'blur'},
  ],
  type: [
    {required: true, message: '请选择类型', trigger: 'blur'},
  ],
  dateTime: [
    {required: true, message: '请选择时间', trigger: 'blur'},
  ],
  chatType: [
    {required: true, message: '请选择展示方式', trigger: 'blur'},
  ]
})
// 点击新增
const addClick = function () {
  dialogFormVisible.value = true
  formData.value = {
    queryName: '',
    type: 1,
    dateTime: [],
    chatType: 1,
    creator: window.localStorage.getItem('memberId'),
  }
}
// 点击编辑
let isCopy = ref()
const editClick = function (id, row, copyFlag) {
  isCopy.value = copyFlag
  dialogFormVisible.value = true
  getSearchDetailApi(id).then(res => {
    if (res.data.code === 200) {
      formData.value = {
        id: id,
        queryName: row.queryName,
        type: row.type,
        chatType: row.chatType,
        dateTime: [row.startTime, row.endTime],
        creator: window.localStorage.getItem('memberId'),
      }
      if (copyFlag) {
        formData.value.id = 0
      }
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 提交
let fromRef = ref()
const save = function () {
  console.log(formData.value, 'qqq')
  // 提交表单
  if (fromRef) {
    fromRef.value.validate((valid) => {
      //提交成功
      if (valid) {
        if (formData.value.id) {
          editSearchListApi(formData.value).then(res => {
            if (res.data.code === 200) {
              getSearchListFun()
              dialogFormVisible.value = false
            } else {
              ElMessage({
                type: 'error',
                message: res.data.message
              })
            }
          }).catch(err => {
            console.log(err);
          })
        } else {
          saveSearchListApi(formData.value).then(res => {
            if (res.data.code === 200) {
              getSearchListFun()
              dialogFormVisible.value = false
            } else {
              ElMessage({
                type: 'error',
                message: res.data.message
              })
            }
          }).catch(err => {
            console.log(err);
          })
        }

      }
    })
  }
}


// 点击删除
const delClick = function (id, row) {
  ElMessageBox.confirm('', '', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    title: '删除查询方案',
    message: h('p', null, [
      h('img', {
        src: 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png',
        style: 'width:20px;height:20px;transform: translateY(4px);margin-right:8px;'
      }, ''),
      h('span', {style: 'color:#595959;'}, '请确认是否要删除此查询方案，删除后数据不可恢复'),
    ])
  }).then(() => {
    delSearchListApi(id).then(res => {
      if (res.data.code === 200) {
        getSearchListFun()
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      type: 'info',
      message: '已取消删除'
    });
  });
}


watch(() => formData.value.dateTime, (val) => {
  if (formData.value.type == 3) {
    disabledDate(new Date(val[0]))
    disabledDate2(new Date(val[1]))
  }
})
const disabledDate = (time) => {
  if (formData.value.dateTime[1]) {
    return time.getTime() >= moment(formData.value.dateTime[1]).valueOf()
  }
  return false
}
const disabledDate2 = (time) => {
  if (formData.value.dateTime[0]) {
    return time.getTime() < moment(formData.value.dateTime[0]).valueOf()
  }
  return false
}


// 筛选树形结构唯一值
const onlySelect = function (data) {
  for (let i = 0; i < data.length; i++) {
    if (data[i].type == 1) {
      data[i].id = data[i].id + '_' + data[i].type
    }
    // data[i].onlyValue = data[i].id + '_' + data[i].type
    if (data[i].subList.length > 0) {
      onlySelect(data[i].subList)
    }
  }
}
// 项目树配置
let props = {
  label: 'name',
  value: 'id',
  children: 'subList',
  disabled: 'isProject',
  isLeaf: (data, node) => {
    if (node.data.type === 2) {
      return true
    }
  }
}
// 树形结构数据
let allTree = ref()
let isAddBtn = ref(false) //判断是否是新增按钮进来
onMounted(() => {
  getSearchListFun()

  // 获取所有设备树
  getAllTreeApi(qs.stringify({
    type: 1
  })).then(async res => {
    if (res.data.code === 0) {
      let data = res.data.result
      await onlySelect(data)
      allTree.value = data
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message,
      })
    }
  }).catch(err => {
    console.log(err);
  })


  if (router.currentRoute.value.query.flag) {
    isAddBtn.value = true
    dialogFormVisible.value = true
  }
  const query = {...route.query};
  // 使用新的查询参数替换当前路由
  router.replace({query});
})


watch(dialogFormVisible, (newVal) => {
  if (!newVal) {
    isAddBtn.value = false
  }
})

</script>

<style lang="less" scoped>
</style>
